import {ONE_HOUR_IN_MS} from '@legit.health/ui';
import {AnamnesisQuestion} from '@/shared/interfaces/AnamnesisQuestion';
import useSuspenseApiQuery from './useSuspenseApiQuery';

const ANAMNESIS_QUESTIONS_LIST = '/anamnesis-questions';

export default function useAnamnesisQuestions() {
  return useSuspenseApiQuery<AnamnesisQuestion[]>({
    queryOptions: {
      queryKey: [ANAMNESIS_QUESTIONS_LIST],
      staleTime: ONE_HOUR_IN_MS
    },
    requestArguments: {
      method: 'GET',
      path: ANAMNESIS_QUESTIONS_LIST
    }
  });
}
